(function () {

    'use strict';

    const STATES = [
        {
            "name": "appointment_data",
            "label": "states_appointment_report",
        },
        {
            "name": "entry_data",
            "label": "states_entry_report",
        }
    ];

    const {BehaviorSubject} = require("rxjs");

    class AppointmentReportCtrl {
        constructor(genericStatesService, system, $translate, $scope, $state, $stateParams, moment) {
            this.genericStatesService = genericStatesService;
            this.system = system;
            this.translate = $translate;
            this.scope = $scope;
            this.$state = $state;
            this.moment = moment;
            this.dateFormat = system['date_format'].js;

            this.currentState = genericStatesService.getCurrentState("appointment_report");

            this.isChart = false;
            this.states = STATES;
            this.activeState = _.get(this.states, '0');

            this.showFilter = true;
            this.query = {
                start: $stateParams.start || this.moment().startOf('month').format(this.dateFormat),
                end: $stateParams.end || this.moment().endOf('month').format(this.dateFormat),
            };

            this.headers = {
                _id: {
                    type: "number",
                    caption: this.translate.instant('unique_id')
                },
                fullname: {
                    type: "string",
                    caption: this.translate.instant('dcm_patient_full_name')
                },
                full_date: {
                    type: "date string",
                    caption: this.translate.instant('appointment_date')
                },
                status: {
                    type: "string",
                    caption: this.translate.instant('appointment_status')
                }
            };
            this.$dataSource = new BehaviorSubject({
                slice: {},
                data: [],
                headers: {},
                onlyData: false
            });
        }

        static get $inject() {
            return ["genericStatesService", "system", "$translate", "$scope", "$state", "$stateParams", "moment"];
        }

        $onInit() {
            this.maxDate = this.moment().toDate();
            this.getData();
        }


        getSlice() {
            return {
                "expands": {
                    "expandAll": true,
                    "rows": [
                        {"tuple": []}
                    ]
                },
                "drills": {
                    "drillAll": false
                },
                "rows": [
                    {
                        "uniqueName": "full_date"
                    },
                    {
                        "uniqueName": "fullname"
                    }
                ],
                "columns": [
                    {
                        "uniqueName": "status"
                    },
                    {
                        "uniqueName": "Measures"
                    }
                ],
                "measures": [
                    {
                        "uniqueName": "total",
                        "caption": this.translate.instant("states_total"),
                        "individual": true,
                        "format": "integer",
                        "formula": "count(\"status\")",
                    }

                ],
            };
        }

        modifyData(data) {
            return _.reduce(data, (result, item) => {
                item.status = this.translate.instant(`states_appointment_${item.status}`);

                return _.concat(result, item);
            }, []);
        }

        getData(onlyData = false) {
            this.promise = this.genericStatesService.getAppointmentReport(
                _.assign(this.query, {data_source: this.activeState.name})
            ).then(data => {
                if (onlyData) {
                    this.$dataSource.next({
                        onlyData: true,
                        data: this.modifyData(data),
                    });
                } else {
                    this.$dataSource.next({
                        slice: this.getSlice(),
                        data: this.modifyData(data),
                        headers: this.headers
                    });
                }
            });
        }

        handleFileName() {
            const start = this.moment(this.query.start, this.dateFormat).format(this.genericStatesService.exportDateFormat);
            const end = this.moment(this.query.end, this.dateFormat).format(this.genericStatesService.exportDateFormat);

            return `${this.translate.instant('states_appointment_file_label', {start, end})}`;
        }

        handleStatesChange() {
            this.scope.$applyAsync(() => this.getData(true));
        }

        queryChanged() {
            const start = this.moment(this.query.start, this.dateFormat);
            const end = this.moment(this.query.end, this.dateFormat);

            if (start.isAfter(end)) this.query.end = start.endOf('month').format(this.dateFormat);

            this.$state.transitionTo(this.$state.current.name, this.query, {
                notify: false
            }).then(() => this.getData(true));
        }

        onComplete(instance) {
            instance.collapseData("full_date")
        }
    }

    module.exports = AppointmentReportCtrl;
})();